import React, { Component } from 'react';
import { Popover, OverlayTrigger, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHatWizard, faHourglass, faCoins, faHourglassHalf, faSave } from '@fortawesome/free-solid-svg-icons';
import Slider from '@material-ui/core/Slider';



class EventsAttendee extends Component {
    constructor(props) {
        super(props);

        this.state = {
            attendStart: new Date(this.props.eventAttendance.data[this.props.attendee].started),
            attendEnd: this.props.eventAttendance.data[this.props.attendee].stopped ? new Date(this.props.eventAttendance.data[this.props.attendee].stopped) : null
        };

    }
    normalizeTime = (event, time) => {
    
        let eventStart = new Date(event.started).getTime()
        let eventEnd = event.stopped ? new Date(event.stopped).getTime() : new Date().getTime()
    
        let epochTime = time ? new Date(time).getTime() : new Date().getTime()
    
        return (epochTime - eventStart) / (eventEnd - eventStart) * 100
    }
    deNormalizeTime = (event, time) => {
        let eventStart = new Date(event.started).getTime()
        let eventEnd = event.stopped ? new Date(event.stopped).getTime() : new Date().getTime()

        let denormalizedStamp = Math.round((time / 100) * (eventEnd - eventStart)) + eventStart

        return new Date(denormalizedStamp)
    }
    handleChange = (event, newValue) => {
        this.setState(prevState => ({ 
            ...prevState, 
            attendStart: this.deNormalizeTime(this.props.event, newValue[0]),
            attendEnd: this.deNormalizeTime(this.props.event, newValue[1])
        }))
    }
    valueLabelFormat = (value) => {
        let time = this.deNormalizeTime(this.props.event, value)

        var hour = time.getHours();
        var min = (time.getMinutes() < 10 ? '0' : '') + time.getMinutes();
        return hour + ":" + min
    }
    render() {
        const { attendee, event } = this.props;
        if (!this.props.edit) {
            return (
                <OverlayTrigger rootClose placement="bottom" overlay={
                    <Popover id={`${attendee}-popover`} style={{"maxWidth":"350px"}}>
                        { parseFloat((new Date(this.props.eventAttendance.data[attendee].stopped).getTime() - new Date(this.props.eventAttendance.data[attendee].started).getTime()) / (new Date(event.stopped).getTime() - new Date(event.started).getTime()) * 100).toFixed(0) < 100 ?
                            (<h6><FontAwesomeIcon className="text-primary" size="sm" icon={faHourglassHalf} fixedWidth /> Attendance</h6>) :
                            (<h6><FontAwesomeIcon className="text-primary" size="sm" icon={faHourglass} fixedWidth /> Attendance</h6>)
                        }
                        { this.props.eventAttendance.data[attendee].stopped ? (
                            <span> <FontAwesomeIcon className="text-primary" size="sm" icon={faHourglassHalf} fixedWidth /> {parseFloat((new Date(this.props.eventAttendance.data[attendee].stopped).getTime() - new Date(this.props.eventAttendance.data[attendee].started).getTime()) / (new Date(event.stopped).getTime() - new Date(event.started).getTime()) * 100).toFixed(0)}% </span>
                            ) : ( 'Active' )
                        }
                        { event.awardedItems
                            .filter((item) => this.props.eventItems.data[item].user === this.props.eventAttendance.data[attendee].user).length ? (
                                <div>
                                    <h6><FontAwesomeIcon className="text-primary" size="sm" icon={faHatWizard} fixedWidth /> Items</h6>
                                        { event.awardedItems
                                            .filter((item) => this.props.eventItems.data[item].user === this.props.eventAttendance.data[attendee].user)
                                            .map((item) => (
                                            <div key={`${item}-item`}>
                                                <h5>{this.props.items.data[this.props.eventItems.data[item].item].title}</h5> <FontAwesomeIcon className="text-primary" size="sm" icon={faCoins} fixedWidth /> {parseFloat(this.props.eventItems.data[item].dkp).toFixed(0)}
                                            </div>
                                        ))}
                                </div>
                            ) : ( null )
                        }
                    </Popover>
                }>
                    <span>
                        <h5 style={(this.props.eventAttendance.data[attendee].stopped === null) ? null : {textDecoration:'line-through'}}>{this.props.users[this.props.eventAttendance.data[attendee].user].displayName}</h5>
                        { event.awardedItems
                            .filter((item) => this.props.eventItems.data[item].user === this.props.eventAttendance.data[attendee].user).length ? (
                                <span> <FontAwesomeIcon className="text-primary" size="sm" icon={faHatWizard} fixedWidth /> {
                                        event.awardedItems
                                            .filter((item) => this.props.eventItems.data[item].user === this.props.eventAttendance.data[attendee].user).length
                                    }
                                </span>
                            ) : ( null )
                        }
                        { this.props.eventAttendance.data[attendee].stopped ? (
                            <span> <FontAwesomeIcon className="text-primary" size="sm" icon={faHourglassHalf} fixedWidth /> {parseFloat((new Date(this.props.eventAttendance.data[attendee].stopped).getTime() - new Date(this.props.eventAttendance.data[attendee].started).getTime()) / (new Date(event.stopped).getTime() - new Date(event.started).getTime()) * 100).toFixed(0)}% </span>
                            ) : (null)
                        }
                    </span>
                </OverlayTrigger>
            )
        } else {
            return (
                <Row>
                    <Col md={1}>
                        <h5 style={(this.props.eventAttendance.data[attendee].stopped === null) ? null : {textDecoration:'line-through'}}>{this.props.users[this.props.eventAttendance.data[attendee].user].displayName}</h5>
                    </Col>
                    <Col md={10}>
                        <Slider
                            value={
                                [
                                    this.normalizeTime(event, this.state.attendStart),
                                    this.normalizeTime(event, this.state.attendEnd)
                                ]
                            }
                            step={0.1}
                            valueLabelDisplay="auto"
                            onChange={this.handleChange}
                            valueLabelFormat={this.valueLabelFormat}
                            marks={
                                event.entities
                                .map((entity) => {                                 
                                    return {
                                    value: this.normalizeTime(event, this.props.eventEntities.data[entity].created),
                                    label: this.props.entities.data[this.props.eventEntities.data[entity].entity].title,
                                } })
                            }
                        />
                    </Col>
                    <div
                        className="pull-right"
                        style={{cursor:"pointer", marginLeft:'5px'}}
                        onClick={() => {
                        let endDiscrepency = this.props.event.stopped ? new Date(this.props.event.stopped) : new Date() 
                        endDiscrepency = (endDiscrepency.getTime() - this.state.attendEnd.getTime()) / 1000
                        this.props.attendeeEdit({
                            event: this.props.event,
                            attendee: {
                                ...this.props.eventAttendance.data[attendee],
                                started: this.state.attendStart,
                                stopped: endDiscrepency < 60 ? null : this.state.attendEnd,
                            }
                        });
                        this.props.editToggle()
                        }}
                    >
                        <FontAwesomeIcon className="text-primary" icon={faSave} fixedWidth />
                    </div>
                </Row>
            )
        }
    }
}

export default EventsAttendee;


// WEBPACK FOOTER //
// ./src/Officer/EventsAttendee.js